module.exports = __webpack_public_path__ + "img/Noticias.8bd45e57.jpg";